module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "prect",
    attrs: {
      "id": "contents"
    }
  }, [_c('a', {
    attrs: {
      "id": "pVIII"
    }
  }), _c('a', {
    attrs: {
      "id": "pIX"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "contents-"
  }, [_c('a', {
    attrs: {
      "href": "#/preface.htm#pre"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "contents--"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction.htm#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-pt"
  }, [_c('a', {
    attrs: {
      "href": "#/part_01.htm#part1"
    }
  }, [_vm._v("PART ONE: E PLURIBUS INC.")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_01.htm#chap1"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_c('b', [_vm._v("1")])]), _vm._v("The Danger and Necessity of Banks")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_02.htm#chap2"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_c('b', [_vm._v("2")])]), _vm._v("A Cheat upon Somebody")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_03.htm#chap3"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_c('b', [_vm._v("3")])]), _vm._v("Inc.")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_04.htm#chap4"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_c('b', [_vm._v("4")])]), _vm._v("The Civil War Tames Currency")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_05.htm#chap5"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_c('b', [_vm._v("5")])]), _vm._v("Sunshine Charlie")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_06.htm#chap6"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_c('b', [_vm._v("6")])]), _vm._v("Radio, Rayon, and Retail Credit")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_07.htm#chap7"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_c('b', [_vm._v("7")])]), _vm._v("If It Seems Too Good to Be True . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_08.htm#chap8"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_c('b', [_vm._v("8")])]), _vm._v("Crash and Contagion")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_09.htm#chap9"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_c('b', [_vm._v("9")])]), _vm._v("Tickled with Poverty")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_10.htm#chap10"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_c('b', [_vm._v("10")])]), _vm._v("Moral Hazard")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-pt"
  }, [_c('a', {
    attrs: {
      "id": "pX"
    }
  }), _c('a', {
    attrs: {
      "href": "#/part_02.htm#part2"
    }
  }, [_vm._v("PART TWO: A WONDERFUL LIFE: SOCIALISM FOR THE RICH")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_11.htm#chap11"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_c('b', [_vm._v("11")])]), _vm._v("Zombie Banks")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_12.htm#chap12"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_c('b', [_vm._v("12")])]), _vm._v("The American Home: Safeguard of American Liberties")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_13.htm#chap13"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_c('b', [_vm._v("13")])]), _vm._v("Financial Cocaine")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_14.htm#chap14"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_c('b', [_vm._v("14")])]), _vm._v("Cover-Up and Bailout")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_15.htm#chap15"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_c('b', [_vm._v("15")])]), _vm._v("Russia Defaults")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_16.htm#chap16"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_c('b', [_vm._v("16")])]), _vm._v("The Committee to Save the World")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_17.htm#chap17"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_c('b', [_vm._v("17")])]), _vm._v("Dysfunctional Oversight")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_18.htm#chap18"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_c('b', [_vm._v("18")])]), _vm._v("Enron: The Emperor’s New Clothes")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-pt"
  }, [_c('a', {
    attrs: {
      "href": "#/part_03.htm#part3"
    }
  }, [_vm._v("PART THREE: ILL-GOTTEN GAIN: BOOM, BUST, AND THE GREAT RECESSION")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_19.htm#chap19"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_c('b', [_vm._v("19")])]), _vm._v("Tent City")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_20.htm#chap20"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_c('b', [_vm._v("20")])]), _vm._v("Financial Magic")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_21.htm#chap21"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_c('b', [_vm._v("21")])]), _vm._v("The Subprime Prisoner’s Dilemma")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_22.htm#chap22"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_c('b', [_vm._v("22")])]), _vm._v("Feds Tell States: Shut Up, Sit Down")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_23.htm#chap23"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_c('b', [_vm._v("23")])]), _vm._v("A Number Out of the Air")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-pt"
  }, [_c('a', {
    attrs: {
      "href": "#/part_04.htm#part4"
    }
  }, [_vm._v("PART FOUR: COCKROACHES IN THE KITCHEN")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_24.htm#chap24"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_c('b', [_vm._v("24")])]), _vm._v("Fake Accounts")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-ct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_25.htm#chap25"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_c('b', [_vm._v("25")])]), _vm._v("Who Should Own a Bank")])]), _vm._v(" "), _c('p', {
    staticClass: "contents--"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#notes"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/bibliography.htm#bib"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/index.htm#index"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 72
// module chunks = 0